import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { fetchRideRequests, updateRideRequest, completeRide } from "../utils/api";
import RequestList from "./RequestList";

export default function RideDetailsDriver({ ride, user, onRideUpdate }) {
  const navigate = useNavigate();
  const token = localStorage.getItem("travelo_token");
  
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadRequests = useCallback(async () => {
    if (!token) return;
    try {
      const data = await fetchRideRequests(ride._id, token);
      setRequests(data.requests || data || []);
    } catch (err) {
      console.error("Driver Fetch Error:", err);
    }
  }, [ride._id, token]);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  const handleAction = async (requestId, action) => {
    try {
      setLoading(true);
      const { request, ride: updatedRide } = await updateRideRequest(ride._id, requestId, action, token);
      setRequests(prev => prev.map(r => r._id === request._id ? request : r));
      if (onRideUpdate) onRideUpdate(updatedRide);
    } catch (err) { 
      alert("Action Failed"); 
    } finally { 
      setLoading(false); 
    }
  };

  const handleCompleteRide = async () => {
    if (!window.confirm("Mark trip as finished?")) return;
    try {
      setLoading(true);
      const updatedRide = await completeRide(ride._id, token);
      if (onRideUpdate) onRideUpdate(updatedRide);
    } catch (err) { 
      alert("Error completing ride"); 
    } finally { 
      setLoading(false); 
    }
  };

  // 🚨 SAFE STATUS CHECK: Forces lowercase to prevent matching errors
  const rideStatus = String(ride?.status || '').toLowerCase();

  // 1. COMPLETED UI
  if (rideStatus === 'completed') {
    return (
      <div className="rd-status-box complete-driver">
        <span className="icon">🏁</span>
        <p>You have completed this ride.</p>
      </div>
    );
  }

  // 2. CANCELLED UI (🚨 This was entirely missing!)
  if (rideStatus === 'cancelled') {
    return (
      <div className="rd-status-box error-box">
        <h3>🚫 Ride Cancelled</h3>
        <p>You have cancelled this ride.</p>
        {ride.cancelReason && (
          <p style={{ fontStyle: 'italic', marginTop: '10px', color: '#991B1B' }}>
            Reason: "{ride.cancelReason}"
          </p>
        )}
      </div>
    );
  }

  // 3. ACTIVE RIDE UI
  return (
    <>
      {requests.length > 0 && (
        <div className="rd-card">
          <h3 className="rd-section-title">Passenger Requests</h3>
          <RequestList 
            requests={requests} 
            handleAction={handleAction} 
            seatsFull={ride.seatsAvailable === 0} 
          />
        </div>
      )}
      <div className="rd-btn-group">
        {/* Navigates to Cancel Page to collect Driver's reason */}
        <button className="rd-btn outline danger" onClick={() => navigate(`/ride/${ride._id}/cancel`)}>
          Cancel Ride
        </button>
        <button className="rd-btn primary success" onClick={handleCompleteRide} disabled={loading}>
          Complete Ride
        </button>
      </div>
    </>
  );
}